import {GET_AUTH_OPTION_SUCCESS} from "../actions/AuthOptionActions";

const initialState = {
    data: {
        countries: [],
        subscribe: false,
    },
    loading: true,
};

export default function AuthOptionsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_AUTH_OPTION_SUCCESS:
            return {
                data: action.payload,
                loading: false,
            };
    }

    return state;
}